const setGoogleMap = () => {
                   
    /*
     * Centrum Warszawa: 52.232855, 20.9211126
     */
    var pos = {
            lat: 52.232855,
            lng: 20.9211126
        }
        
    var gpsLat = $('#gps-latitude').val();
    var gpsLng = $('#gps-longitude').val();
    
    if (gpsLat != "" && gpsLng != ""){
        pos = {
            lat: gpsLat,
            lng: gpsLng
        }
    }
        
    var mapCenter = new google.maps.LatLng(pos.lat, pos.lng),
        laptop_width = 1200,
        isDraggable = document.body.clientWidth >= laptop_width ? true : false,
        args = {
            zoom: 13,
            center: mapCenter,
            zoomControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            draggable: isDraggable,
            scrollwheel: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };


    // Create a map object and specify the DOM element for display.
    window.map = new google.maps.Map(document.getElementById('map'), args);
    
    var styles = [];

    var userPin = new google.maps.LatLng(pos.lat, pos.lng);
    window.marker = new google.maps.Marker({
        position: userPin,
        map: map,
        icon: "/img/front/pin.png",
        draggable: true
    });
    
    window.markerPopup = new google.maps.InfoWindow({
        content     : "Aktualna lokalizacja",
    });
    
    google.maps.event.addListener(marker, 'click', function() {
        markerPopup.open( map, marker );
    });
    
    google.maps.event.addListener(marker, 'dragend',function() {
        // console.log(marker.position.lat() +' '+marker.position.lng());
        $('#gps-latitude').val(marker.position.lat());
        $('#gps-longitude').val(marker.position.lng());
        
        $('.order-results').slideUp(function(){});

        var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
        var geocoder = new google.maps.Geocoder();

        geocoder.geocode({ 'latLng': latlng }, function (results, status) {
            if (status !== google.maps.GeocoderStatus.OK) {
                console.log(status);
            }

            if (status == google.maps.GeocoderStatus.OK) {
                
                var premise = "";
                var streetAddress = "";
                var streetNumber = "";
                var zipCode = "";
                var city = "";
                var country = "";

                results[0].address_components.forEach(function(item){
                    if (item.types.indexOf("premise") != -1) {
                        premise = item.long_name;
                    }

                    if (item.types.indexOf("street_number") != -1) {
                        streetNumber = item.long_name;
                    }

                    if (item.types.indexOf("route") != -1) {
                        if (item.long_name != "Unnamed Road"){
                            streetAddress = item.long_name;
                        }
                    }

                    if (item.types.indexOf("locality") != -1) {
                        city = item.long_name;
                    }

                    if (item.types.indexOf("postal_code") != -1) {
                        zipCode = item.long_name;
                    }
                    
                    if (item.types.indexOf("country") != -1) {
                        country = item.long_name;
                    }
                });

                if (streetAddress == "" && premise != ""){
                    if (city != ""){
                        streetAddress = city + ' ' + premise;
                    } else {
                        streetAddress = premise;
                    }
                }
                
                // var addressPopup = (results[0].formatted_address);
                var addressPopup = streetAddress + " " + streetNumber + ", " + city + ", " + country;

                if(addressPopup != ""){
                    markerPopup.setContent(addressPopup);
                    markerPopup.open(map, marker);
                }

                $('#locationStreet').val((streetAddress + " " + streetNumber).trim());
                // console.log($('#locationStreet').val() + ' ' + $('#locationStreet').val().length);
                // $('#locationZipCode').val(zipCode.trim());
                $('#locationCity').val(city.trim());
                
                if($('#locationStreet').val().trim() == "" || $('#locationStreet').val().trim() == " "){
                    $('#locationStreet').closest('.form-group').addClass('error');
                } else {
                    $('#locationStreet').closest('.form-group').removeClass('error');
                    $('#locationStreet').attr('aria-invalid', false);
                    $('#locationStreet-error').css('display', 'none');
                }

                if($('#locationZipCode').val().trim() == "" || $('#locationZipCode').val().trim() == " "){
                    $('#locationZipCode').closest('.form-group').addClass('error');
                } else {
                    $('#locationZipCode').closest('.form-group').removeClass('error');
                    $('#locationZipCode').attr('aria-invalid', false);
                    $('#locationZipCode-error').css('display', 'none');
                }

                if($('#locationCity').val().trim() == "" || $('#locationCity').val().trim() == " "){
                    $('#locationCity').closest('.form-group').addClass('error');
                } else {
                    $('#locationCity').closest('.form-group').removeClass('error');
                    $('#locationCity').attr('aria-invalid', false);
                    $('#locationCity-error').css('display', 'none');
                }
                
                var url = $('.btn-show-price').attr('base-path');
                var currZipCode = $('#locationZipCode').val();
                
                // currZipCode vs city
                var data = {
                    postalCode: currZipCode.trim(),
                    city: city.trim()
                };

                $.ajax({
                    type: 'POST',
                    data: data,
                    dataType: "json",
                    url: url + 'ajax/searchPostalCode',
                    success: function(response) {
                        console.log(response);
                        if (response.status == true){
                            $('#locationZipCode').closest('.form-group').removeClass('error');
                            $('#locationZipCode').attr('aria-invalid', false);
                            $('#locationZipCode-error').css('display', 'none');
                            
                            $('#locationCity').closest('.form-group').removeClass('error');
                            $('#locationCity').attr('aria-invalid', false);
                            $('#locationCity-error').css('display', 'none');
                            
                        } else {
                            $('#locationZipCode').closest('.form-group').addClass('error');
                            $('#locationZipCode').attr('aria-invalid', true);
                            $('#locationZipCode').attr('aria-describedby', 'locationZipCode-error');
                            if ( $( "#locationZipCode-error" ).length ) {
                                $('#locationZipCode-error').html('Kod nieprawidłowy dla podanego miasta, popraw kod ręcznie.');
                                $('#locationZipCode-error').css('display', 'block');
                            } else {
                                $('#locationZipCode').closest('.form-group').append('<span id="locationZipCode-error" class="error show" style="">Kod nieprawidłowy dla podanego miasta, popraw kod ręcznie.</span>');
                            }
                            
                            $('#locationCity').closest('.form-group').addClass('error');
                            $('#locationCity').attr('aria-invalid', true);
                            $('#locationCity').attr('aria-describedby', 'locationCity-error');
                            if ( $( "#locationCity-error" ).length ) {
                                $('#locationCity-error').html('Miasto nieprawidłowe dla podanego kodu, popraw miasto ręcznie.');
                                $('#locationCity-error').css('display', 'block');
                            } else {
                                $('#locationCity').closest('.form-group').append('<span id="locationCity-error" class="error show" style="">Miasto nieprawidłowe dla podanego kodu, popraw miasto ręcznie.</span>');
                            }
                            
                            $('.map-cover').fadeIn();
                            $('#location-error').slideUp();
                            $('#locationAcc').val("");
                            $('.order-results').slideUp();

                            $('.btn-show-price').hide();
                            $('.btn-submit-form').html('Wyceń').show();

                            if($('#progress-location').hasClass('done')){
                                $('#progress-location').removeClass('done bounceIn animated');
                                $('.progress-box .progress-bar').css('width', 0+'%');
                                $('.progress-box .label-progress').html(0 +'%');
                            }
                            
                            var offset = $('#locationZipCode').offset().top-100;

                            $('html, body').animate({
                                scrollTop: offset
                            }, 500);
                        }
                    },
                    error: function(response) {
                        console.log(response);
                        $('#locationZipCode').closest('.form-group').addClass('error');
                        $('#locationZipCode').attr('aria-invalid', true);
                        $('#locationZipCode').attr('aria-describedby', 'locationZipCode-error');
                        if ( $( "#locationZipCode-error" ).length ) {
                            $('#locationZipCode-error').html('Kod nieprawidłowy dla podanego miasta, popraw kod ręcznie.');
                            $('#locationZipCode-error').css('display', 'block');
                        } else {
                            $('#locationZipCode').closest('.form-group').append('<span id="locationZipCode-error" class="error show" style="">Kod nieprawidłowy dla podanego miasta, popraw kod ręcznie.</span>');
                        }

                        $('#locationCity').closest('.form-group').addClass('error');
                        $('#locationCity').attr('aria-invalid', true);
                        $('#locationCity').attr('aria-describedby', 'locationCity-error');
                        if ( $( "#locationCity-error" ).length ) {
                            $('#locationCity-error').html('Miasto nieprawidłowe dla podanego kodu, popraw miasto ręcznie.');
                            $('#locationCity-error').css('display', 'block');
                        } else {
                            $('#locationCity').closest('.form-group').append('<span id="locationCity-error" class="error show" style="">Miasto nieprawidłowe dla podanego kodu, popraw miasto ręcznie.</span>');
                        }

                        $('.map-cover').fadeIn();
                        $('#location-error').slideUp();
                        $('#locationAcc').val("");
                        $('.order-results').slideUp();

                        $('.btn-show-price').hide();
                        $('.btn-submit-form').html('Wyceń').show();

                        if($('#progress-location').hasClass('done')){
                            $('#progress-location').removeClass('done bounceIn animated');
                            $('.progress-box .progress-bar').css('width', 0+'%');
                            $('.progress-box .label-progress').html(0 +'%');
                        }

                        var offset = $('#locationZipCode').offset().top-100;

                        $('html, body').animate({
                            scrollTop: offset
                        }, 500);
                    }
                });
            }
        });
    });

    map.setOptions({
        styles: styles
    });    
    
    return map;
}

module.exports = {
    setGoogleMap, 
};